import React, { useEffect, useState } from 'react';
import './App.scss';

import { Route, Routes } from 'react-router-dom';

import ApiService from './services/Api';
import HomePage from './pages/HomePage';
import InterestProgramPage from './pages/InterestProgramPage';
import GeneralDataPage from './pages/GeneralDataPage';
import AditionalDataPage from './pages/AditionalDataPage';
import SpouseDataPage from './pages/SpouseDataPage';
import FinancingPage from './pages/FinancingPage';
import { Tools } from './utils/tools';
import AcademicInformationPage from './pages/AcademicInformationPage';
import WorkingInformationPage from './pages/WorkingInformationPage';
import WorkingDataPage from './pages/WorkingDataPage';
import PresentationLetterPage from './pages/PresentationLetterPage';
import PayMethodPage from './pages/PayMethodPage';
import DocumentationPage from './pages/DocumentationPage';
import FinishPage from './pages/FinishPage';
import Preloading from './assets/images/preloader.svg';
import { useNavigate } from "react-router-dom";
import { LinkedInCallback } from 'react-linkedin-login-oauth2';

if (!localStorage.getItem('app_sp')) { localStorage.setItem('app_sp', '') } // Programa seleccionado
localStorage.setItem('app_fd', Tools.cryptrData('{"general_data": null, "aditional_data": null, "spouse_data": null}'));

function App() {
  let navigate = useNavigate();
  let _localStorage = localStorage;

  const [initdata, setInit] = useState(false);

  useEffect(() => {
    const init = async () => {
      await ApiService.postKcLogin()
        .then((res) => {
          _localStorage.setItem('tokenukc', res.data.access_token);
          setInit(true);
        });
    }

    init();
  }, [_localStorage]);

  return (
    <>
      {
        (initdata)
          ?
          <Routes>
            <Route path="/" exact element={<HomePage navigate={navigate} />} />
            <Route path="/programa-interes" exact element={<InterestProgramPage navigate={navigate} />} />
            <Route path="/datos-generales" exact element={<GeneralDataPage navigate={navigate} />} />
            <Route path="/datos-adicionales" exact element={<AditionalDataPage navigate={navigate} />} />
            <Route path="/datos-conyuge" exact element={<SpouseDataPage navigate={navigate} />} />
            <Route path="/financiamiento" exact element={<FinancingPage navigate={navigate} />} />
            <Route path="/informacion-academica" exact element={<AcademicInformationPage navigate={navigate} />} />
            <Route path="/informacion-laboral" exact element={<WorkingInformationPage navigate={navigate} />} />
            <Route path="/datos-laborales" exact element={<WorkingDataPage navigate={navigate} />} />
            <Route path="/carta-presentacion" exact element={<PresentationLetterPage navigate={navigate} />} />
            <Route path="/forma-pago" exact element={<PayMethodPage navigate={navigate} />} />
            <Route path="/documentacion" exact element={<DocumentationPage navigate={navigate} />} />
            <Route path="/inscripcion_finalizada" exact element={<FinishPage navigate={navigate} />} />
            <Route exact path="/linkedin" element={<LinkedInCallback />} />
          </Routes>
          :
          <></>
      }
      <div id="preloader">
        <img src={Preloading} alt='' />
      </div>
    </>
  );
}

export default App;